import type { QueryClient } from '@tanstack/react-query';
import type { AgentsDataConfig } from '../../config';

import { NO_COMPUTER_SELECTION } from './desktopTargetSelection';
import { fetchCurrentDesktopTarget } from './resolveDesktopTargetTurn';

type ResolveWorkflowRunRequestExtras = NonNullable<
  AgentsDataConfig['resolveWorkflowRunRequestExtras']
>;

type RunRequestExtrasInput = Parameters<ResolveWorkflowRunRequestExtras>[1];

/**
 * Sends the user's Run by pick for this run. Without one, the backend applies
 * the routine's preferred computer, then this computer.
 */
// eslint-disable-next-line @heidi/rules/no-new-carved-domain-data -- app-side resolveRunRequestExtras binding: roster + Tauri caps cannot live in @heidi/agents/data; kept out of workflows/hooks.ts so the Green routines excludedSymbols ratchet does not grow
export const resolveWorkflowRunRequestExtras = async (
  queryClient: QueryClient,
  { desktopTargetOverride }: RunRequestExtrasInput
) => {
  if (desktopTargetOverride) {
    return desktopTargetOverride === NO_COMPUTER_SELECTION
      ? { no_computer: true }
      : { target_id: desktopTargetOverride };
  }
  const target = await fetchCurrentDesktopTarget(queryClient).catch(() => undefined);
  return target?.target_id ? { fallback_target_id: target.target_id } : {};
};
